import { render, staticRenderFns } from "./WebcamButton.vue?vue&type=template&id=559e615a"
import script from "./WebcamButton.vue?vue&type=script&lang=js"
export * from "./WebcamButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports